export const ORCID_PATTERN_STRING =
  '^[Hh][Tt][Tt][Pp][Ss]://orcid.org/\\d{4}-\\d{4}-\\d{4}-\\d{3}[0-9xX]$';

export const ORCID_PATTERN = new RegExp(ORCID_PATTERN_STRING);

const ORCID_URL_PREFIX = /^https?:\/\/orcid\.org\//i;

export function matchesOrcidPattern(input: string): boolean {
  return ORCID_PATTERN.test(input.trim());
}

/** Strips URL prefix and hyphens; returns 16 chars (15 base digits + check) or null. */
export function normalizeOrcidDigits(input: string): string | null {
  const trimmed = input.trim();
  let body = trimmed;
  if (ORCID_URL_PREFIX.test(trimmed)) {
    body = trimmed.replace(ORCID_URL_PREFIX, '');
  }
  const digits = body.replace(/-/g, '').toUpperCase();
  if (!/^\d{15}[\dX]$/.test(digits)) {
    return null;
  }
  return digits;
}

/** ISO/IEC 7064 MOD 11-2 per ORCID identifier spec. */
export function generateOrcidCheckDigit(baseDigits: string): string {
  let total = 0;
  for (let i = 0; i < baseDigits.length; i++) {
    const digit = Number(baseDigits.charAt(i));
    total = (total + digit) * 2;
  }
  const remainder = total % 11;
  const result = (12 - remainder) % 11;
  return result === 10 ? 'X' : String(result);
}

export function isValidOrcidChecksum(input: string): boolean {
  const normalized = normalizeOrcidDigits(input);
  if (normalized === null) {
    return false;
  }
  const base = normalized.slice(0, 15);
  const check = normalized.charAt(15);
  return generateOrcidCheckDigit(base) === check;
}
